/**
 * Description — the prose card that sits below the producer row.
 *
 * Reads `event.description` (markdown). Renders raw text in v1; markdown
 * parsing via react-markdown can plug in here without changing the
 * primitive's contract.
 *
 * Config:
 *  - `showMore` — a "Show more" toggle that collapses after the first paragraph, once collapsing is built. Until then
 *    the whole description shows and no toggle renders: a "Show more" that can't be pressed looks like a control.
 */

import { registerPrimitive, type PrimitiveProps } from '../../layout'
import { useEvent } from '../../destination'

export interface DescriptionConfig {
  showMore?: boolean
}

export function EventDescription(_props: PrimitiveProps) {
  const event = useEvent()

  if (!event.description) return null

  const paragraphs = event.description
    .split(/\n\n+/)
    .map((p) => p.trim())
    .filter(Boolean)

  return (
    <div className="lv-desc">
      {paragraphs.map((p, i) => (
        <p key={i}>{p}</p>
      ))}
    </div>
  )
}

registerPrimitive('EventDescription', EventDescription)
registerPrimitive('Description', EventDescription)
